import FindingsList from './FindingsList';
import { listAllFindings } from '../../../services/securityhubApi';

// GuardDuty findings. Reuse the unified findings source scoped to the guardduty
// engine (the normalized shape FindingsList expects); FindingDetail fetches the
// raw GuardDuty payload and renders the AWS-console-style GuardDutyDetailBody.
const gdSource = (filters) => listAllFindings({ ...filters, engine: ['guardduty'] });

export default function GuardDutyFindings() {
  return (
    // `color` paints the shared FindingsList page header in the GuardDuty accent
    // so this route matches Entry / Setup / Enrollment / Settings.
    <FindingsList
      source={gdSource}
      engineKind="guardduty"
      subtitle="GuardDuty findings"
      color="#E65100"
    />
  );
}
